module.exports = __webpack_public_path__ + "/login_ui/img/gb-334e7105ff562de70df01bc698db0568.svg";